import { designerEngine } from "@/components/designer/engine/DesignerEngine";
import { PRODUCTS, type ProductType } from "@/components/designer/products";
import { useDesignerStore } from "@/components/designer/store";
import { meApi } from "@/lib/api";

// Serialize the current canvas and persist it as a per-user design (a saved
// studio session). T-shirts store both sides; gang sheets store one canvas.
// Returns the new design id.
export async function saveCurrentDesign(product: ProductType, name: string): Promise<string> {
  const canvas = designerEngine.getCanvas();
  if (!canvas) throw new Error("Canvas not ready");
  const cfg = PRODUCTS[product];

  const store = useDesignerStore.getState();
  const color = store.garmentColor;

  let data: string;
  if (cfg.kind === "tshirt") {
    // Flush the visible side into the store, then bundle both sides + colour.
    store.setSideData(store.side, JSON.stringify(canvas.toJSON()));
    const sd = useDesignerStore.getState().sideData;
    data = JSON.stringify({
      v: 2,
      color,
      sides: {
        front: sd.front ? JSON.parse(sd.front) : null,
        back: sd.back ? JSON.parse(sd.back) : null,
      },
    });
  } else {
    data = JSON.stringify(canvas.toJSON());
  }

  let thumbnail = "";
  try {
    thumbnail = canvas.toDataURL({ format: "jpeg", quality: 0.5, multiplier: 0.25 });
    if (thumbnail.length > 480_000) thumbnail = ""; // keep the payload small
  } catch {
    /* tainted canvas (cross-origin image) — skip thumbnail */
  }

  const res = await meApi.createDesign({
    name,
    product,
    kind: cfg.kind,
    color: cfg.kind === "tshirt" ? color : undefined,
    width_mm: cfg.sizeMm.width,
    height_mm: cfg.sizeMm.height,
    data,
    thumbnail,
  });
  return res.id;
}
